import DOMPurify from "dompurify";

export const ArticleBody = ({ html, testid = "article-body" }) => (
  <div className="article-content" data-testid={testid} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html || "", { USE_PROFILES: { html: true }, FORBID_TAGS: ["img", "iframe", "style", "form", "input", "button"], FORBID_ATTR: ["style"] }) }} />
);